import { render, staticRenderFns } from "./ReporteLeads.vue?vue&type=template&id=32c04d52"
import script from "./ReporteLeads.vue?vue&type=script&lang=js"
export * from "./ReporteLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports